import React, { useEffect, useState } from 'react'
import {
    Text,
    View,
    TextInput,
    Image,
    StyleSheet,
    TouchableOpacity,
    Keyboard,
    StatusBar,
} from 'react-native'
import { FormFieldsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import styles from './InputCommentFieldStyles'
import theme from '../../../../theme'
import { schedulesServices } from '../../../../database/schedules.database'
import { updateFormAnswerSchedule } from '../../../../db-sqlite/repositories/schedule.repository'
import { getLanguage } from '../../appBar/context/LocalizationContext'

interface InputCommentFieldProps {
    item: FormFieldsModel
    form_id: string
    schedule_id: string
    store_id: string
    answerProp: ModelAnswerFromProps
    closeBottomSheet: (l: boolean) => void
    checkComplete: (option?: ModelAnswerFromProps) => void
    keyboardHiddenState: boolean
    onFocus: (id: string) => void
    activeInputId: string
    saveItemSteps?: (option?: ModelAnswerFromProps) => void
    onSubInputMeasure?: (id: string, screenY: number, inputH: number) => void
}

export const InputCommentField = ({
    item,
    form_id,
    schedule_id,
    store_id,
    answerProp,
    closeBottomSheet,
    checkComplete,
    keyboardHiddenState,
    onFocus,
    activeInputId,
    saveItemSteps,
    onSubInputMeasure,
}: InputCommentFieldProps) => {
    const { languageFile } = getLanguage()

    const [text, setText] = useState('')
    const inputRef = React.useRef<TextInput>(null)

    useEffect(() => {
        // answerProp puede venir compartido entre varios fields de la misma acción;
        // solo tomamos field_text si realmente es la respuesta de este field.
        if (
            answerProp?._id === item._id &&
            answerProp?.field_text &&
            answerProp?.field_text !== ''
        ) {
            setText(answerProp.field_text)
        }
    }, [])
    useEffect(() => {
        if (keyboardHiddenState && activeInputId == item._id) {
            if (text !== '') {
                validateAnswer(text)
            }
        }
    }, [keyboardHiddenState])
    const validateAnswer = (answer: string) => {
        console.log('Entro al validate')
        if (answer.trim() != '') {
            console.log("text.trim() != ''")
            create_answer(answer)
        }
    }

    const create_answer = (inputText: string) => {
        try {
            console.log('Valido la rta')
            if (saveItemSteps) {
                const answer: ModelAnswerFromProps = {
                    _id: item._id,
                    option_selected_text: [],
                    option_selected_id: [],
                    question_id: item._id ?? '',
                    media: '',
                    question_text: item.label ?? '',
                    score: answerProp?.score ? String(answerProp.score) : '0',
                    status: 1,
                    date_finish: new Date().toISOString(),
                    date_init: new Date().toISOString(),
                    question_input: '',
                    field_media: '',
                    field_text: inputText,
                    questionScore: answerProp?.questionScore,
                    index: answerProp?.index,
                    type: (item as any).type as number,
                    ponderar: !!(
                        answerProp?.questionScore && answerProp?.questionScore > 0
                    ),

                    question: answerProp?.question_text ?? '',
                    questionOptionSelected: [],
                    questionOptionSelectedText: [],
                    questionType: answerProp?.questionType,
                    questionPrice: '',
                    tag: '',
                    questionImage: '',
                    questionInput: inputText,
                    sku: (answerProp as any)?.sku,
                    description: (answerProp as any)?.description ?? '',
                    description_short: (answerProp as any)?.description_short ?? '',
                }
                saveItemSteps(answer)
            } else {
                const answer: ModelAnswerFromProps = {
                    _id: item._id,
                    option_selected_text: answerProp.option_selected_text,
                    option_selected_id: answerProp.option_selected_id,
                    question_id: answerProp.question_id,
                    media: '',
                    question_text: answerProp.question_text,
                    score: answerProp.score ? answerProp.score.toString() : '0',
                    status: 1,
                    date_finish: new Date().toString(),
                    date_init: new Date().toString(),
                    question_input: '',
                    field_media: '',
                    field_text: inputText,
                    questionScore: answerProp.questionScore,
                    index: answerProp.index,
                    type: answerProp.type,
                    ponderar:
                        answerProp.questionScore && answerProp.questionScore > 0, // [7, 8, 14, 18].includes(answerProp.type),

                    question: answerProp?.question_text,
                    questionOptionSelected: [],
                    questionOptionSelectedText: [],
                    questionType: answerProp.questionType,
                    questionPrice: '',
                    tag: '',
                    questionImage: '',
                    questionInput: inputText,
                    sku: answerProp.sku,
                    description: answerProp.description ?? '',
                    description_short: answerProp.description_short ?? '',
                }

                if (form_id) {
                    updateFormAnswerSchedule({
                        newAnswer: answer,
                        schedule_id,
                        form_id,
                        store_id,
                    })
                }
                if (saveItemSteps) {
                    saveItemSteps(answer)
                }
                checkComplete(answer)
                // Keyboard.dismiss()
            }
        } catch (error) {
            console.error('Error al validar la rta')
        }
    }

    return (
        <View>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
            {typeof (item as any).media === 'string' &&
                (item as any).media !== '' && (
                    <Image
                        style={styles.image}
                        source={{ uri: (item as any).media as string }}
                    />
                )}

            {item.title && <Text style={styles.title}>{item.title}</Text>}
            {item.label && <Text style={styles.subtitle}>{item.label}</Text>}
            <TextInput
                ref={inputRef}
                style={styles.input}
                onChangeText={(text) => setText(text)}
                placeholder={languageFile.enter_a_comment}
                placeholderTextColor={theme.colors.inputPlaceholder}
                value={text}
                onSubmitEditing={() => validateAnswer(text)}
                onEndEditing={(e) => validateAnswer(e.nativeEvent.text)}
                onFocus={() => {
                    onFocus && onFocus(item._id)
                    if (onSubInputMeasure) {
                        inputRef.current?.measureInWindow((x, y, w, h) => {
                            onSubInputMeasure(item._id, y, h)
                        })
                    }
                }}
                autoFocus={activeInputId === item._id}
            />

            {/* <View style={styles.buttonContainer}>
                <TouchableOpacity style={styles.borderButton} onPress={validateAnswer}>
                    <Text style={styles.borderButtonText}>{languageFile.confirm}</Text>
                </TouchableOpacity>
            </View> */}
        </View>
    )
}
